module.exports = __webpack_public_path__ + "img/event-cover.d6f25809.png";